import React, { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Flex,
} from '@chakra-ui/react';
import { Chart } from '../Chart';
import { Divider } from '../Divider';

const TabGroup = ({ data }) => {
  const { tabs, title } = data;
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    // Reset the selected tab when the tabs data changes
    setSelectedTab(0);
  }, [tabs]);

  return (
    <Container maxWidth='container.xl' mt={30}>
      <Divider />

      <Tabs
        index={selectedTab}
        onChange={(index) => setSelectedTab(index)}
        isLazy
        display='flex'
        flexDirection={{ base: 'column', md: 'row' }}
        gap={{ base: 2, md: 30 }}
      >
        <Flex
          direction='column'
          flex={{ base: 1, md: 2 }}
          borderRight='1px solid'
          borderColor={{ base: 'transparent', md: 'lightGrey' }}
          pr={{ base: 0, md: 30 }}
          mb={{ base: 4, md: 0 }}
        >
          <Text textStyle='h2' as='h2' mb={2}>
            {title}
          </Text>
          <TabList borderBottom='none' flexDirection='column' gap={10}>
            <Box>By:</Box>
            {tabs.map((tab, index) => (
              <Tab
                _selected={{ bg: 'navy', color: 'white' }}
                _hover={{ bg: 'orange', color: 'black' }}
                bg='grey.light'
                color='navy'
                textStyle='navItem'
                fontSize='0.875rem'
                letterSpacing='1px'
                key={index}
                padding={10}
                borderRadius='5px'
                justifyContent='flex-start'
              >
                {tab.title}
              </Tab>
            ))}
          </TabList>
        </Flex>

        <TabPanels flex={{ base: 1, md: 9 }}>
          {tabs.map(({ _key, chart }) => (
            <TabPanel key={_key} padding='0'>
              <Box>{chart && <Chart data={chart} />}</Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default TabGroup;
